var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "campaign-section__holder", class: _vm.widgetHolderClass },
    [
      _c("div", { staticClass: "campaign-section__header" }, [
        _c("div", { staticClass: "campaign-section__header_content" }, [
          _c(
            "div",
            { staticClass: "campaign-section__header_title" },
            [
              _c(
                "span",
                {
                  staticClass: "campaign-section__heading_title",
                  class: _vm.widgetTitleCustomClass
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.widgetTitle) + "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _vm._t("titleExtra")
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "campaign-section__header_right_content" },
            [
              _vm._t("headerExtra", function() {
                return [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-list-function pull-right panel-collpase-toggle-btn",
                      attrs: { href: "javascript:;" },
                      on: { click: _vm.onShowContentsClick }
                    },
                    [
                      _c("i", {
                        staticClass: "typcn",
                        class: {
                          "typcn-arrow-sorted-up": _vm.showContent,
                          "typcn-arrow-sorted-down": !_vm.showContent
                        },
                        attrs: { "aria-hidden": "true" }
                      })
                    ]
                  )
                ]
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showContent,
              expression: "showContent"
            }
          ],
          staticClass: "campaign-section__content"
        },
        [
          _vm._t("content"),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }